import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AmToasterService } from '@angularminds/am-toaster';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AuthService } from 'src/app/services/auth.service';
import { FormValidator } from 'src/app/services/form-validator/form-validator';
import { GeneralService } from 'src/app/services/general.service';
import { RestService } from 'src/app/services/rest.service';

@Component({
  selector: 'app-change-email',
  templateUrl: './change-email.component.html',
  styleUrls: ['./change-email.component.css']
})
export class ChangeEmailComponent implements OnInit {

  form: FormGroup;
  isButtonDisabled: boolean = false;
  validateStatus: string;
  customErrors: any = {};
  user: any
  isSubmitted: boolean;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  constructor(
    private fb: FormBuilder,
    private restService: RestService,
    private authService: AuthService,
    private generalService: GeneralService,
    private bsModalRef: BsModalRef,
    public router: Router,
    private amToasterService: AmToasterService,
  ) { }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.form = this.fb.group({
      email: ['', [Validators.required]],
      code: ['']
    });
  }

  applyValidations() {
    for (const i in this.form.controls) {
      if (this.form.controls.hasOwnProperty(i)) {
        this.form.controls[i].markAsDirty();
        this.form.controls[i].updateValueAndValidity();
      }
    }
  }

  disableWhiteSpace(event) {
    return FormValidator.restrictWhiteSpace(event);
  }

  cancel(): void {
    this.bsModalRef.hide();
  }

  isShoVerification: any
  sendVerificationNumber(reSendOTP?: Boolean) {
    this.isButtonDisabled = true;
    this.isOtpSending = true;
    this.isSubmitted = true;
    this.restService.post(`/api/users/update/email/${this.user._id}?send_otp=true`, { email: this.form.get('email').value }).subscribe((resp: any) => {
      if (resp) {
        this.isShoVerification = resp.showVerification
        this.isButtonDisabled = false;
        this.isOtpSending = false;
        if (reSendOTP) {
          clearInterval(this.interval);
          this.time = 300
        }
        this.startTimer();
      }
    }, error => {
      if (error == 'Error: Invalid second factor code') {
        this.errorMsg = "Error: Invalid email verification code"
      } else {
        this.errorMsg = error
      }
      if (error == 'Error: Code is required') {
        this.form.controls.code.setErrors({ notValid: true });
      } else {
        this.form.controls.email.setErrors({ notValid: true });
      }
      this.isButtonDisabled = false;
      this.isOtpSending = false;
    })
  }

  errorMsg
  submitForm(): void {
    this.isSubmitted = true;
    this.applyValidations();
    if (this.form.invalid) {
      return;
    }
    this.isButtonDisabled = true;
    this.restService.post(`/api/users/update/email/${this.user._id}`, { email: this.form.get('email').value, code: this.form.get('code').value }).subscribe((resp: any) => {
      if (resp) {
        this.amToasterService.show("success", "Email update successfully", "Success")
        this.isButtonDisabled = false;
        this.authService.loadCurrentUser().subscribe(res => {
          this.time = 1;
          this.passEntry.emit();
          this.cancel()
        })
      }
    }, error => {
      if (error == 'Error: Invalid second factor code') {
        this.errorMsg = "Error: Invalid email verification code"
      } else {
        this.errorMsg = error
      }
      if (this.isShoVerification) {
        this.form.controls.code.setErrors({ notValid: true });
      } else {
        this.form.controls.email.setErrors({ notValid: true });
      }
      this.isButtonDisabled = false;
    })
  }
  time: number = 300; // 3 minutes timeout
  interval: any;
  play: boolean = false;
  isOtpSending: boolean = false
  startTimer() {
    this.play = true;
    this.interval = setInterval(() => {
      this.time--;
      if (this.time === 0) {
        clearInterval(this.interval);
      }
    }, 1000);
  }

  get email() {
    return this.form.controls.email;
  }

  get f() {
    return this.form.controls;
  }

}
